import initialState from 'src/store/state'

// Target State
const moduleState = initialState.result

// Actions
const SET_DATA = 'SET_DATA'
const SET_STORAGE = 'SET_STORAGE'
const SET_CLIENTNAME = 'SET_CLIENTNAME'
const REMOVE_STORAGE = 'REMOVE_STORAGE'
const SET_RESPONSE = 'SET_RESPONSE'
// const SET_VISITED_BODYTYPE = 'SET_VISITED_BODYTYPE'
// const SET_VISITED_OTHERREC = 'SET_VISITED_OTHERREC'
const SET_VISITED_QUESTIONNAIRE = 'SET_VISITED_QUESTIONNAIRE'

// export const setVisitedBodytype = (data:object) => {
//   return {
//     type: SET_VISITED_BODYTYPE,
//     payload: { data }
//   }
// }

// export const setVisitedOtherRec = (data:object) => {
//   return {
//     type: SET_VISITED_OTHERREC,
//     payload: { data }
//   }
// }

export const setResponse = (data:object) => {
  return {
    type: SET_RESPONSE,
    payload: { data }
  }
}

export const setVisitedQuestionnaire = (data:object) => {
  return {
    type: SET_VISITED_QUESTIONNAIRE,
    payload: { data }
  }
}

export const setData = (data:object) => {
  return {
    type: SET_DATA,
    payload: { data }
  }
}

export const setStorage = (data:object) => {
  return {
    type: SET_STORAGE,
    payload: { data }
  }
}

export const setClientname = (data:object) => {
  return {
    type: SET_CLIENTNAME,
    payload: { data }
  }
}

export const removeStorage = (data:object) => {
  return {
    type: REMOVE_STORAGE,
    payload: { data }
  }
}
const reducers = (state = moduleState, action: any) => {
  switch (action.type) {
    // case SET_VISITED_BODYTYPE: {
    //   const data = action.payload.data
    //   state.isVisitedBodytype = data.isVisited
    //   return Object.assign({}, state)
    // }
    // case SET_VISITED_OTHERREC: {
    //   const data = action.payload.data
    //   state.isVisitedOtherRec = data.isVisited
    //   return Object.assign({}, state)
    // }
    case SET_RESPONSE: {
      const data = action.payload.data
      state.response = data
      return Object.assign({}, state)
    }
    case SET_VISITED_QUESTIONNAIRE: {
      const data = action.payload.data
      state.isVisitedQuestionnaire = data.isVisited
      return Object.assign({}, state)
    }
    case SET_DATA: {
      const data = action.payload.data
      state.data = data.result_data
      data.storage_data && state.storageKey && localStorage.setItem(state.storageKey, data.storage_data)
      return Object.assign({}, state)
    }
    case SET_STORAGE: {
      const data = action.payload.data
      data.storage_data && state.storageKey && localStorage.setItem(state.storageKey, data.storage_data)
      return Object.assign({}, state)
    }
    case SET_CLIENTNAME: {
      const data = action.payload.data
      state.clientNameKey && localStorage.setItem(state.clientNameKey, data.client_name)
      return Object.assign({}, state)
    }
    case REMOVE_STORAGE: {
      state.storageKey && localStorage.getItem(state.storageKey) && localStorage.removeItem(state.storageKey)
      return Object.assign({}, state)
    }
    default:
      return state
  }
}

export default reducers
